import { render, staticRenderFns } from "./DashVarejoGrafico.vue?vue&type=template&id=104b23e0&"
import script from "./DashVarejoGrafico.vue?vue&type=script&lang=js&"
export * from "./DashVarejoGrafico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports